import { AppShell } from "./components/AppShell";
import { FlowProvider, useFlow } from "./flow/FlowContext";
import { WelcomeScreen } from "./screens/WelcomeScreen";
import { FaithConfirmScreen } from "./screens/FaithConfirmScreen";
import { CommunityRulesScreen } from "./screens/CommunityRulesScreen";
import { IntentScreen } from "./screens/IntentScreen";
import { AccountScreen } from "./screens/AccountScreen";
import { VerifyIntroScreen } from "./screens/VerifyIntroScreen";
import { VerifyIdScreen } from "./screens/VerifyIdScreen";
import { VerifyVideoScreen } from "./screens/VerifyVideoScreen";
import { VerifyPhotosScreen } from "./screens/VerifyPhotosScreen";
import { VerifyReviewScreen } from "./screens/VerifyReviewScreen";
import { SetupIntroScreen } from "./screens/SetupIntroScreen";
import { WhyChristianScreen } from "./screens/WhyChristianScreen";
import { ValueScalesScreen } from "./screens/ValueScalesScreen";
import { AboutYouScreen } from "./screens/AboutYouScreen";
import { LookingForScreen } from "./screens/LookingForScreen";
import { LoveReadyScreen } from "./screens/LoveReadyScreen";
import { LifestyleScreen } from "./screens/LifestyleScreen";
import { FaithDepthScreen } from "./screens/FaithDepthScreen";
import { CharacterScreen } from "./screens/CharacterScreen";
import { HistoryScreen } from "./screens/HistoryScreen";
import { AppearanceScreen } from "./screens/AppearanceScreen";
import { HomeAndLandScreen } from "./screens/HomeAndLandScreen";
import { FamilyScreen } from "./screens/FamilyScreen";
import { AncestryScreen } from "./screens/AncestryScreen";
import { InterestsScreen } from "./screens/InterestsScreen";
import { ReflectionScreen } from "./screens/ReflectionScreen";
import { ProfileScreen } from "./screens/ProfileScreen";
import { ReadyScreen } from "./screens/ReadyScreen";

function FlowRouter() {
  const { stepId, goToStep } = useFlow();

  let screen = null;
  switch (stepId) {
    case "welcome":
      screen = <WelcomeScreen />;
      break;
    case "faithConfirm":
      screen = <FaithConfirmScreen />;
      break;
    case "communityRules":
      screen = <CommunityRulesScreen />;
      break;
    case "intent":
      screen = <IntentScreen />;
      break;
    case "account":
      screen = <AccountScreen />;
      break;
    case "verifyIntro":
      screen = <VerifyIntroScreen />;
      break;
    case "verifyId":
      screen = <VerifyIdScreen />;
      break;
    case "verifyVideo":
      screen = <VerifyVideoScreen />;
      break;
    case "verifyPhotos":
      screen = <VerifyPhotosScreen />;
      break;
    case "verifyReview":
      screen = <VerifyReviewScreen />;
      break;
    case "setupIntro":
      screen = <SetupIntroScreen />;
      break;
    case "whyChristian":
      screen = <WhyChristianScreen />;
      break;
    case "valueScales":
      screen = <ValueScalesScreen />;
      break;
    case "aboutYou":
      screen = <AboutYouScreen />;
      break;
    case "lookingFor":
      screen = <LookingForScreen />;
      break;
    case "loveReady":
      screen = <LoveReadyScreen />;
      break;
    case "lifestyle":
      screen = <LifestyleScreen />;
      break;
    case "faithDepth":
      screen = <FaithDepthScreen />;
      break;
    case "character":
      screen = <CharacterScreen />;
      break;
    case "history":
      screen = <HistoryScreen />;
      break;
    case "appearance":
      screen = <AppearanceScreen />;
      break;
    case "homeAndLand":
      screen = <HomeAndLandScreen />;
      break;
    case "family":
      screen = <FamilyScreen />;
      break;
    case "ancestry":
      screen = <AncestryScreen />;
      break;
    case "interests":
      screen = <InterestsScreen />;
      break;
    case "reflection":
      screen = <ReflectionScreen />;
      break;
    case "profile":
      screen = <ProfileScreen />;
      break;
    case "ready":
      screen = <ReadyScreen />;
      break;
    default:
      screen = (
        <div className="screen-enter" style={{ flex: 1 }}>
          <header className="screen-head">
            <h1 className="screen-head__title">This step is missing</h1>
            <p className="screen-head__text">
              Something went wrong in the questions. Go back to the start — your saved answers stay on this phone.
            </p>
          </header>
          <button type="button" className="match-nav__link" onClick={() => goToStep("welcome")}>
            Back to welcome
          </button>
        </div>
      );
  }

  return <AppShell>{screen}</AppShell>;
}

export default function App() {
  return (
    <FlowProvider>
      <FlowRouter />
    </FlowProvider>
  );
}
